import { updateLinksAttributes } from '../../utils/handleAttributes';
import { getWindowSize } from '../../utils/helpers';

export default function mainCards() {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;
  const $widget = $(`#${widgetName}`);
  const isDesktop = getWindowSize(800);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createmainCards(data.items, isDesktop);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });

  function createmainCards(widgetData, isDesktop) {
    $widget.find('.card-content').remove();
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.find('.image-container').append(`
          <div class='card-content'>
            <span class='widget-title'>${Title}</span>
          </div>`);

      validateUrl(URL, $cardItem);
      updateLinksAttributes(URL, Title, $cardItem);
      addAosAnimation($cardItem, x, isDesktop);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}

function addAosAnimation($cardItem, x, isDesktop) {
  $cardItem.attr({
    'data-aos': isDesktop ? 'fade-down' : 'zoom-in',
    'data-aos-delay': x * 200,
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '400',
    'data-aos-once': 'true',
    'data-aos-offset': isDesktop ? '350' : '150',
  });
}
